import { post, get, put, api_token, token, DEV_TOKEN } from './api.js';

export function action(code, game, action) {
    return post('quizz/',
        {
            c: code,
            g: game,
            a: action
        }, token || DEV_TOKEN);
}

export function join(code, game, team, id, old_team, old_id) {
    let payload = { c: code, g: game, a: "join" };
    if (team) {
        payload.t = team;
        payload.i = id;
    }
    if (old_id) {
        payload.oi = old_id;
        payload.ot = old_team;
    }
    
    return post('quizz/', payload, token || DEV_TOKEN);
}

export function push(code, game, user, team, response) {

    let payload = { c: code, g: game, r: response, u: user };
    if (team) {
        payload.t = team;
    }

    return put('quizz/', payload, token || DEV_TOKEN);
}

export function load(code, game, current, content, team) {

    let url = `quizz/?c=${code}`;
    if (game) {
        url += `&g=${game}`;
    }
    if (current) {
        url += `&current=true`;
    }

    if (content) {
        url += `&content=true`;
    }

    if (team) {
        url += `&t=${window.btoa(team)}`;
    }

    return get(url, token || DEV_TOKEN);
}

export function teamName(code, team) {
    return get(`teams/?c=${code}&t=${team}`, token || DEV_TOKEN);
}

export function results(code, game, item, team) {
    let url = `quizz/?c=${code}`;
    if (game) {
        url += `&g=${game}`;
    }

    if (team) {
        url += `&t=${team}`;
    }

    if (item) {
        url += `&i=${item}`;
    }
    return get(url, token || DEV_TOKEN);
}
